import React from 'react';

import { cssMap } from '@atlaskit/css';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Box, Stack } from '@atlaskit/primitives/compiled';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	card: {
		width: '100%',
		maxWidth: '380px',
		borderRadius: token('radius.large'),
		overflow: 'hidden',
		backgroundColor: token('elevation.surface.overlay'),
	},
	cardDefiniteWidth: {
		width: '380px',
		borderRadius: token('radius.large'),
		overflow: 'hidden',
		backgroundColor: token('elevation.surface.overlay'),
	},
	body: {
		paddingTop: token('space.400'),
		paddingLeft: token('space.200'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.200'),
	},
});

export const AgentProfileCardSkeleton = (): React.JSX.Element => {
	return (
		<Box
			xcss={
				fg('agent_profile_card_loading_skeleton_definite_width')
					? styles.cardDefiniteWidth
					: styles.card
			}
		>
			<Skeleton width="100%" height="96px" borderRadius={0} />
			<Stack xcss={styles.body} space="space.150">
				<Stack space="space.050">
					<Skeleton width="160px" height="20px" />
					<Skeleton width="120px" height="16px" />
				</Stack>
				<Skeleton width="100%" height="48px" />
				<Skeleton width="100%" height="32px" />
			</Stack>
		</Box>
	);
};
